// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"Block\"] {\n  position: relative;\n  transition: opacity 50ms ease-in;\n  opacity: 1;\n}\n  [name=\"Block\"].disabled {\n    opacity: 0.5;\n  }\n  [name=\"Block\"] .curtain {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }", ""]);
// Exports
module.exports = exports;
